export { default } from './Icons';
export type { Props, Props as SectionNavigationIconsProps } from './Icons';
